module.exports = __webpack_public_path__ + "img/androidPos.c81ac014.jpg";